import api from "./api";

export function getJobPage(country_id) {
    return api.get(`/jobpage/${country_id}`);
}

export function createJobPage(data) {
    return api.post("/jobpage", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function updateJobPage(country_id, data) {
    return api.put(`/job-page/${country_id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
